import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageBody } from '../../../elements/page-body';
import { Table } from '../../../elements/table';
import { RenderFilters } from '../../../elements/render-filters';
//import { ShipmentForm } from './shipment-form';

export const RoutesConfig = () => {
    const navigate = useNavigate();
    const [refresh, setRefresh] = useState<string | null>(null);
    const [filters, setFilters] = useState<any>({});
    const [query, setQuery] = useState<any>(new URLSearchParams(filters));

    const handleNewAction = () => {
        navigate('/route-configs/create');
    };

    const doFilter = (filters: any) => {
        setFilters(filters);
        setQuery(new URLSearchParams(filters));
        setRefresh(Date.now().toString());
    };

    return (
        <PageBody
            newAction={handleNewAction}
            title={'common.label.configuracion-rutas'}
            newActionTitle={'common.form-title.new'}
        >
            <>
                {Object.keys(filters).length > 0 ? <RenderFilters filters={filters} /> : ''}
                <Table
                    path="/fleet/route-configs/"
                    deletePath="/fleet/route-configs/"
                    //Form={ShipmentForm}
                    withPagination
                    doEdit={(item: any) => navigate(`/route-configs/${item.id}`)}
                    query={query}
                    refresh={refresh}
                    headers={[
                        {
                            key: 'name',
                            label: 'common.label.name'
                        }
                    ]}
                />
            </>
        </PageBody>
    );
};
